import React, { useState } from "react";
import { Link } from "react-router-dom";
import { DocumentIcon, MusicCircleicon, FavoritesIcon } from "../components";
import { Loader2 } from "lucide-react";

const FavoritesCard = ({ item, onToggleFavorite }) => {
  const {
    id,
    slug,
    title,
    imageUrl,
    aboutHours,
    catList,
    favorite,
    contentType,
    catechesis,
    count,
  } = item;

  const [isLoading, setIsLoading] = useState(false);

  const pathMap = {
    "catecheses": "learn-the-faith",
    "prayer-rites": "prayer-and-rites",
    "culture-customs": "culture-and-customs",
    'catechetical-course': 'catechetical-courses',
    'devotion': 'devotions',
    'meditation': 'meditations',
  };

  const path = `/${pathMap[contentType] || contentType}/${slug}`;

  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 backdrop-blur-sm rounded-xl z-10">
          <Loader2 className="animate-spin h-10 w-10 text-gold-600" />
        </div>
      )}

      <Link to={path}>
        <div className="flex flex-row">
          {/* Image */}
          {/* <div className="w-[80px]">
            <img
              src={imageUrl}
              alt={title}
              className="block h-full bg-gray-200 max-h-98 max-w-20 rounded-bl-xl rounded-tl-xl w-[64px] object-cover"
            />
          </div> */}

          {/* Content */}
          <div className="flex flex-col w-full px-4 py-3 bg-gold-50  rounded-xl">
            <p className="text-base font-semibold leading-5 text-left text-gray-900 cursor-pointer">
              {title}
            </p>

            {/* Catechesis + Duration */}
            <div className="flex gap-3 mt-1">
              {catechesis && (
                <div className="flex items-center gap-1">
                  <DocumentIcon className="text-gray-600" />
                  <p className="text-xs font-normal leading-4 text-gray-600">
                    {count} catechesis
                  </p>
                </div>
              )}
              {aboutHours && (
                <div className="flex items-center gap-1">
                  <MusicCircleicon className="text-gray-600" />
                  <p className="text-xs font-normal leading-4 text-gray-600">
                    {aboutHours}
                  </p>
                </div>
              )}
            </div>

            {/* Categories + Favorite */}
            <div className="flex justify-end mt-2.5">
              {Array.isArray(catList) && catList.filter(Boolean).length > 0 && (
                <div className="flex gap-2">
                  {catList.filter(Boolean).map((category, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 text-xs font-medium leading-4 bg-white-50 text-gold-500 rounded-27"
                    >
                      {category}
                    </span>
                  ))}
                </div>
              )}

              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onToggleFavorite(id, e);
                }}
                className="flex items-center focus:outline-none"
                aria-label={favorite ? "Remove from favorites" : "Add to favorites"}
              >
                <FavoritesIcon
                  filled={Boolean(favorite)}
                  className={`h-6 w-6 transition-colors duration-200 ${
                    favorite
                      ? "text-red-100"
                      : "text-gray-500 hover:text-red-100"
                  }`}
                />
              </button>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default FavoritesCard;
